
define('VintenCloud.Downloads.Downloads', [

    'VintenCloud.Downloads.Downloads.View',
    "Profile.Model",
    "MyAccountMenu",
    "underscore",
    "Utils",
], function (

    DownloadsView,
    Profile_Model,
    MyAccountMenu,
    _,
    Utils

) {
    'use strict';

    function addMenuItems(myAccountMenu) {
        var menuItems = [{
            id: "downloadspage",
            groupid: "orders",
            name: _.translate("Downloads"),
            url: "downloads",
            index: "8",
        },];
        _.each(menuItems, function (item) {
            myAccountMenu.addGroupEntry(item);
        });
    }

    function registerPages(pageType) {
        var pages = [{
            name: _.translate("Downloads"),
            view: DownloadsView,
            routes: ['downloads', 'download?:options'],
            defaultTemplate: {
                name: 'vintencloud_downloads_downloads.tpl',
                displayName: 'Downloads'
            },
        },];
        _.each(pages, function (page) {
            pageType.registerPageType(page);
        });
    }


    return {
        mount: function mount(container) {
            console.log("Load Downloads");
            //var profile = Profile_Model.getInstance();
            //if (profile.attributes.role === 1069) {
                var myAccountMenu = container.getComponent("MyAccountMenu");
                var pageType = container.getComponent("PageType");

                if (myAccountMenu) {
                    addMenuItems(myAccountMenu);
                }

                if (pageType) {
                    registerPages(pageType);
                }
            //}

        }
    };
});
